import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export interface IImageResponse {
  image: string;
}

const fetchBase64Image = async (
  questionId: number,
  mode: "mobile" | "desktop"
): Promise<IImageResponse | false> => {
  try {
    const config: AxiosRequestConfig = {
      method: "POST",
    //   url: `${process.env.REACT_APP_HOST}/api/ultra/slika-base64`,
      // url: `https://quiz-back.firebird.rs/api/ultra/slika-base64`,
      
      // Lokalno (development)
      // url: `http://localhost:6002/api/ultra/slika-base64`,
      
      // Produkcija
      url: `https://politehnika-back.firebird.rs/api/ultra/slika-base64`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        mode,
        questionId,
      },
    };

    const response: AxiosResponse = await axios(config);
    return response.data.data;
  } catch (error) {
    console.error("Greška u fetchBase64Image:", error);
    return false;
  }
};

export default fetchBase64Image;
